import { apiClient } from '@/api/client'
import { ApiError, parseProblemDetails } from '@/api/problemDetails'

import type { ChannelSummary } from './types'

/**
 * O endpoint de listagem de canais (`GET /tenants/{tenantId}/channels`) tem `.Produces<T>()` no
 * OpenAPI, entao `result.data` ja vem tipado pelo `openapi-fetch`. So resta o `undefined` defensivo
 * (a uniao de status codes do schema inclui respostas sem corpo tipado).
 */
function unexpectedFormatError(status: number): ApiError {
  return new ApiError({
    title: 'A resposta da Api nao tem o formato esperado.',
    status,
    errorCode: 'internal_error',
    correlationId: '',
  })
}

/** Lista os canais do tenant e o status de conexao de cada um (hoje: WhatsApp). */
export async function listChannels(tenantId: string): Promise<readonly ChannelSummary[]> {
  const result = await apiClient.GET('/api/v1/tenants/{tenantId}/channels', {
    params: { path: { tenantId } },
  })

  if (!result.response.ok) {
    throw new ApiError(parseProblemDetails(result.error, result.response.status))
  }

  if (result.data === undefined) {
    throw unexpectedFormatError(result.response.status)
  }

  return result.data
}
